module.exports = __webpack_public_path__ + "img/logo.b7b64407.png";